import _defineProperty from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/defineProperty";
export function TermQuery(key, value) {
  return {
    term: _defineProperty({}, key, value)
  };
}